<div class="w-full relative">
  @if(isToday) {
  <div
    class="absolute left-12 w-[96%] flex justify-between items-center h-[30px]"
    [style.top.px]="px"
  >
    <small class="flex-0 mr-2 bg-red-500 rounded-md px-1 text-white">
      {{ actualTime }} {{ timeReference }}
    </small>
    <hr class="flex-1 border-0 h-[2px] bg-red-500" />
  </div>
  } @for (event of events; track $index) {
  <c-simple-event [event]="event" [index]="$index" />
  }

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">0a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">1 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">2 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">3 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">4 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">5 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">6 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">7 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">8 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">9 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">10 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">11 a.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">12 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">13 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">14 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">15 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">16 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">17 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">18 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">19 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">20 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">21 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">22 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">23 p.m.</small>
    <hr class="flex-1" />
  </div>

  <div class="w-full flex justify-between items-center h-[30px]">
    <small class="flex-0 mr-2">24 p.m.</small>
    <hr class="flex-1" />
  </div>
</div>
